const list = {
  // =================================================================================================================
  components () {
    return [
      {'component': 'search-start-end', label: '작성일', value:'date', query:{'ss':'startDate', 'ee':'endDate'}, options:{}},
      {'component': 'search-column-keyword', label: '검색조건', value:'column', query:{'ck_t':'head', 'ck_k':'keyword'},
        options: { hiddenList: ['부서명', '조사일', '작성일']}},
    ]
  },
  getConditions: (nav) => {
    const conditions = [];
    const search = nav.value;

    //  작성일
    if (search.date) {
      conditions.push({key: 'created_at', operator: '>=', value: search.date.startDate})
      conditions.push({key: 'created_at', operator: '<', value: search.date.endDate ? new Date(search.date.endDate).addDays(1).format("yyyy-MM-dd") : ''})
    }

    //  검색조건
    const heads = list.getHead().map(e => {return {[e.name] : e.key}});
    // 배열의 객체들을 하나의 객체로 합치기
    const types = Object.assign({}, ...heads);
    if (search.column && search.column.keyword) {
      conditions.push({key: types[search.column.head], operator: 'LIKE', value: `%${search.column.keyword}%`})
    }
    return conditions;
  },


  // =================================================================================================================
  getHead: () => {
    return [
      {
        "name": "부서명",
        "key": "field.com_name",
        "sortKey": false
      },
      {
        "name": "팀명",
        "key": "field.team_company_list[%].com_name",
        "sortKey": false
      },
      {
        "name": "사업장명",
        "key": "body.stdInfo.field_name"
      },
      {
        "name": "작업내용",
        "key": "body.inputB_1"
      },
      {
        "name": "조사일",
        "key": "body.inputB_5"
      },
      {
        "name": "소속명",
        "key": "body.stdInfo.department"
      },
      {
        "name": "작성자",
        "key": "body.stdInfo.writer_name"
      },
      {
        "name": "작성일",
        "key": "body.created_at"
      }
    ]
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
        case 0: {
          const meta = JSON.parse(value.field.meta || '{}')
          return func.getContent(value).stdInfo.부서명_과 || meta.com_name // 부서명_과
        }
        case 1: {
          const team_company_list = JSON.parse(value.field.meta || '{}').team_company_list;
          return team_company_list ? team_company_list.map(team => team.com_name).join(', ') : '-';
        }
        case 2: return func.getContent(value).stdInfo.field_name // 사업장명
        case 3: return func.getContent(value).inputB_1 // 작업내용
        case 4: return func.getContent(value).inputB_5 // 조사일
        case 5: return func.getContent(value).stdInfo.department // 소속명
        case 6: return func.getContent(value).stdInfo.writer_name // 작성자
        case 7: return func.getCreatedDate(value.created_at) // 작성일
      }
    } catch (e) { /*ignore*/ }
    return ''
  },
  getSearchKeyValue: (nav) => {},
  getSearchKeyword: (nav) => {},
}
export default list;
